<template>
  <div>
    <info-sidebar
      :sidebarInfoActive.sync="sidebarInfoActive"
      :user="user"
      @open-sidebar-form="openSidebarForm"
    />
    <form-sidebar :sidebarFormActive.sync="sidebarFormActive" :user="user" />
    <div class="custom-search">
      <b-row class="mb-2">
        <b-col md="3">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            @click="() => (sidebarFormActive = true)"
            variant="outline-primary"
          >
            ADICIONAR
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label>Pesquisar:</label>
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Status:</label>
            <b-form-select v-model="statusSelected" :options="statusOptions" />
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="users"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
      @on-row-click="onRowClick"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'name'" class="text-nowrap">
          <b-avatar :src="props.row.avatar" class="mx-1" />
          <span>{{ props.row.name }}</span>
        </span>
        <span
          v-else-if="
            props.column.field === 'birthDate' ||
              props.column.field === 'dueDate'
          "
          class="text-nowrap"
        >
          {{
            props.formattedRow[props.column.field] | dateFormat("DD/MM/YYYY")
          }}
        </span>
        <span
          v-else-if="props.column.field === 'deletedAt'"
          class="text-nowrap"
        >
          {{ props.formattedRow[props.column.field] ? "Desativado" : "Ativo" }}
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Exibindo 1 até
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> de {{ props.total }} registros </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BRow,
  BCol,
} from "bootstrap-vue";

import InfoSidebar from "./info-sidebar/InfoSidebar.vue";
import FormSidebar from "./form-sidebar/FormSidebar.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";

import store from "@/store";

export default {
  components: {
    BAvatar,
    BButton,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    VueGoodTable,
    InfoSidebar,
    FormSidebar,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },

  directives: {
    Ripple,
  },

  data() {
    return {
      pageLength: 5,
      dir: false,
      columns: [
        {
          label: "Nome",
          field: "name",
        },
        {
          label: "E-mail",
          field: "email",
        },
        {
          label: "Telefone",
          field: "telephone",
        },
        {
          label: "Aniversário",
          field: "birthDate",
        },
        {
          label: "Status",
          field: "deletedAt",
        },
      ],
      rows: [],
      sidebarInfoActive: false,
      sidebarFormActive: false,
      user: {},
      statusSelected: null,
      statusOptions: [
        { value: null, text: "Selecione uma opção" },
        { value: "ativos", text: "ATIVOS" },
        { value: "desativados", text: "DESATIVADOS", disabled: false },
      ],

      searchTerm: "",
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },

    users() {
      return this.rows.filter((filter) => {
        let checkStatus =
          !this.statusSelected ||
          (this.statusSelected == "desativados" && filter.deletedAt !== null) ||
          (this.statusSelected == "ativos" && filter.deletedAt === null);

        return checkStatus;
      });
    },
  },

  watch: {
    "$store.state.user.list"(list) {
      this.rows = list;
    },

    sidebarInfoActive(active) {
      if (!active) setTimeout(() => (this.user = {}), 200);
    },
  },

  async created() {
    await store.dispatch("user/fetch");
  },

  methods: {
    advanceSearch(val) {
      this.searchTerm = val;
    },

    async openSidebarForm() {
      this.sidebarFormActive = true;
    },

    async onRowClick(params) {
      if (params.row.id != undefined) {
        const user = this.rows.find((u) => u.id == params.row.id);
        this.user = user;
        this.sidebarInfoActive = true;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
